import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TLikeStatus } from '../../types/developerV2/review';

export enum EReviewActionTypes {
  SetReviewReaction = 'developer/setReviewReaction',
}

export type TSetReviewReactionActionPayload = {
  reviewId: string;
  type: TLikeStatus;
};

export type TSetReviewReaction = ITypedReduxAction<
  EReviewActionTypes.SetReviewReaction,
  TSetReviewReactionActionPayload
>;

/**
 * Redux action, который записывает в store новый лайк/дизлайк пользователя
 */
export const setReviewReactionAction: (payload: TSetReviewReactionActionPayload) => TSetReviewReaction =
  actionGenerator<EReviewActionTypes.SetReviewReaction, TSetReviewReactionActionPayload>(
    EReviewActionTypes.SetReviewReaction,
  );
